module.exports = __webpack_public_path__ + "static/img/img-iccid-zh.23ca780.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/img-iccid-zh.jpg
// module id = 4nWU
// module chunks = 1